module.exports={
	"Scope": "ReportNamedInstance-List",
	"CoreEntity": "ReportNamedInstance",
	"TitleTemplate": "Report Named Instances",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "RNIListName",
			"PictDashboard": {}
		},
		"Hash":
		{
			"Name": "Hash",
			"Hash": "RNIListHash",
			"PictDashboard": {}
		},
		"DefaultReport":
		{
			"Name": "Default",
			"Hash": "RNIListDefault",
			"PictDashboard":
			{
				"ValueTemplate": "<div class=\"has-text-centered\">{~HCS:Record.Payload.DefaultReport~}<span class=\"icon has-text-success\"><i class=\"fas fa-circle-check\"></i></span>{~HCE:Record.Payload.DefaultReport~}{~HCS:Record.Payload.DefaultReport:true~}<span class=\"icon has-text-grey\"><i class=\"fas fa-circle-xmark\"></i></span>{~HCE:Record.Payload.DefaultReport:true~}</div>"
			}
		}
	}
}
